import React from 'react';
import FbFieldAssigmentItem from './FbFieldAssigmentItem';

export const FB_METADATA_OPTIONS = [];

class FbFieldAssigment extends React.Component {

  constructor(props) {
    super(props);
    this.fieldList = [];
    for(let i = 0; i < props.fields.length; i++) {
      this.fieldList.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
        type: props.fields[i].field_type, label: props.fields[i].label_name });
    }
  }

  buildKeyOptions = () => {
    const questions = (this.props.fbFields || []).map(q => ({
      value: q.key, label: `${q.label} (${q.key})`
    }));
    return [
      { label: 'Form Questions', options: questions },
      ...FB_METADATA_OPTIONS
    ];
  };

  render() {
    // Only SIMPLE mappings "own" a key. Tokens used inside composers are read-only
    // usage, so they must not disable options elsewhere.
    const usedKeys = (this.props.value || [])
      .filter(v => !v.parts)
      .map(v => v.key)
      .filter(k => k);

    const fields = (this.props.value || []).map(fieldAssmnt => {
      const field = this.fieldList.find(field => field.value === fieldAssmnt.field);
      return { key: fieldAssmnt.key, field, parts: fieldAssmnt.parts };
    });

    return fields.map((field, i) =>
      <FbFieldAssigmentItem key={`fb_field_assigment_item_${i}`} value={field}
        index={i} fields={this.fieldList} keyOptions={this.buildKeyOptions()}
        usedKeys={usedKeys} zones={this.props.zones} dZone={this.props.dZone}
        api_data={this.props.api_data}
        onAdd={this.props.onAdd} onEdit={this.props.onEdit}
        onDelete={this.props.onDelete} onFormat={this.props.onFormat} />
    );
  }
}
export default FbFieldAssigment;